"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _renderprops = require("react-spring/renderprops");
var _theme = _interopRequireDefault(require("@a1s/theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const HIGHLIGHT_COLOR = 'deepSkyBlue';
const Overlay = ({
  onMouseLeave,
  onMouseMove,
  tooltipData,
  tooltipOpen,
  xMax,
  yMax
}) => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_renderprops.Spring, {
    config: _renderprops.config.default,
    from: {
      opacity: 0
    },
    to: {}
  }, () => tooltipData ? /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    cx: tooltipData.x,
    cy: tooltipData.y,
    fill: _theme.default.colors[HIGHLIGHT_COLOR],
    fillOpacity: tooltipOpen ? 1 : 0,
    r: tooltipData.size + 1,
    stroke: _theme.default.colors[HIGHLIGHT_COLOR],
    strokeWidth: (0, _polished.rem)(1),
    strokeOpacity: tooltipOpen ? 1 : 0
  })) : null), /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "0",
    width: xMax,
    height: yMax,
    fill: "transparent",
    onMouseLeave: onMouseLeave,
    onMouseMove: event => onMouseMove(event)
  }));
};
var _default = Overlay;
exports.default = _default;